import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import DMCElection from "@/pages/DMCElection";
import Vision from "@/pages/Vision";
import Research from "@/pages/Research";
import Endorsements from "@/pages/Endorsements";
import Awards from "@/pages/Awards";
import Connect from "@/pages/Connect";
import Gallery from "@/pages/Gallery";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Supporters from "@/pages/admin/Supporters";
import ResearchAdmin from "@/pages/admin/ResearchAdmin";
import EndorsementsAdmin from "@/pages/admin/EndorsementsAdmin";
import GalleryAdmin from "@/pages/admin/GalleryAdmin";
import AwardsAdmin from "@/pages/admin/AwardsAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import { getToken } from "@/lib/api";

function RequireAuth({ children }) {
  return getToken() ? children : <Navigate to="/admin/login" replace />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/dmc-election" element={<DMCElection />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/research" element={<Research />} />
            <Route path="/endorsements" element={<Endorsements />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/gallery" element={<Gallery />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="supporters" element={<Supporters />} />
            <Route path="research" element={<ResearchAdmin />} />
            <Route path="endorsements" element={<EndorsementsAdmin />} />
            <Route path="gallery" element={<GalleryAdmin />} />
            <Route path="awards" element={<AwardsAdmin />} />
            <Route path="settings" element={<SettingsAdmin />} />
          </Route>
        </Routes>
        <Toaster richColors position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
